(function () {
    var STORAGE_KEY = 'karinex_cookie_consent';
    // Steht oben, weil alreadyAnswered() schon beim Laden liest (var weiter unten waere dann noch undefined).
    var SETTINGS_KEY = 'karinex_cookie_settings';
    // Version der Einwilligung (Wunsch der Inhaberin vom 31.10.2026: wer vor den Aenderungen am Cookie-Fenster
    // geantwortet hat, sieht den Hinweis beim naechsten Besuch noch einmal). Steht als _v in karinex_cookie_settings,
    // also kein neuer Speicher-Schluessel. Bis zur neuen Antwort gilt die alte Auswahl weiter (Cookiebot, Shopify,
    // kxConsent lesen sie unveraendert). Alle noch einmal fragen = diesen Wert erhoehen.
    // 2026-11-02: neuer Schalter „Verhalten je Besuch“ (analytics.visit_profile), alle werden neu gefragt.
    // 2026-11-04: neue Schalter „Klicks, Scrollen und Ladezeiten“ (analytics.heatmaps) und „Sitzungsaufnahme“
    // (analytics.session_replay), Wahl der Inhaberin: alle werden einmal neu gefragt.
    var CONSENT_VERSION = '2026-11-04';
    var banner = document.getElementById('kxCookieBanner');
    var backdrop = document.getElementById('kxCookieBackdrop');
    if (!banner) return;

    // Irgendeine fruehere Antwort (auch aus einer aelteren Version)
    function hadAnswered() {
      try { return !!localStorage.getItem(STORAGE_KEY); } catch (e) { return false; }
    }
    // Antwort zur aktuellen Version: nur dann bleibt der Hinweis zu
    function alreadyAnswered() {
      if (!hadAnswered()) return false;
      var s = readSettings();
      return !!s && s._v === CONSENT_VERSION;
    }
    function save(value) {
      try { localStorage.setItem(STORAGE_KEY, value); } catch (e) {}
    }
    // Shopifys Customer Privacy API liegt NICHT von selbst auf der Seite — sie
    // muss ueber Shopify.loadFeatures() angefordert werden. Live gemessen
    // (19.09.2026): direkt nach dem Laden ist window.Shopify.customerPrivacy
    // undefined, nach loadFeatures(['consent-tracking-api']) vorhanden. Die
    // frueheren Aufrufe standen hinter einem blossen "wenn es sie gibt"-Guard
    // und liefen deshalb ins Leere: die Auswahl des Besuchers wurde gespeichert,
    // aber nie an Shopify gemeldet. Diese Bruecke fordert die API bei Bedarf an
    // und ruft den Callback erst, wenn sie wirklich da ist.
    function withCustomerPrivacy(fn) {
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.setTrackingConsent === 'function') { fn(cp); return; }
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err) return;
          try {
            var api = window.Shopify.customerPrivacy;
            if (api && typeof api.setTrackingConsent === 'function') fn(api);
          } catch (e) {}
        });
      } catch (e) {}
    }
    function notifyShopify(value) {
      var consented = value === 'accepted';
      withCustomerPrivacy(function (cp) {
        try {
          cp.setTrackingConsent({
            analytics: consented,
            marketing: consented,
            preferences: consented,
            sale_of_data: consented
          }, function () {});
        } catch (e) {}
      });
    }

    // === Cookiebot-Bruecke ==========================================
    // Dieses Banner ist die Oberflaeche, Cookiebot der rechtliche Traeger:
    // erst submitCustomConsent() entsperrt die per data-blockingmode="manual"
    // markierten Tracker. Jede Stelle, die notifyShopify() ruft, ruft auch
    // notifyCookiebot() — sonst waere die Auswahl sichtbar gespeichert, aber
    // ohne Wirkung. Alles ist defensiv gekapselt: faellt Cookiebot aus
    // (Adblocker, Netzfehler), verhaelt sich das Banner exakt wie vorher.
    function notifyCookiebot(prefs, stats, marketing) {
      try {
        if (window.Cookiebot && typeof window.Cookiebot.submitCustomConsent === 'function') {
          window.Cookiebot.submitCustomConsent(!!prefs, !!stats, !!marketing);
        }
      } catch (e) {}
    }
    function onCookiebotReady(fn) {
      if (window.Cookiebot && window.Cookiebot.hasResponse !== undefined) { fn(); return; }
      window.addEventListener('CookiebotOnLoad', fn, { once: true });
    }
    // Fruehere Antworten an Cookiebot nachreichen: wer vor der Cookiebot-Einfuehrung
    // (19.09.2026) geantwortet hat, haette dort sonst KEINE Einwilligung und alles
    // bliebe gesperrt. Seit 31.10.2026 sieht jeder ohne aktuelle Version (_v) den
    // Hinweis noch einmal; diese Wiedergabe ueberbrueckt nur die Zeit bis zur neuen Antwort.
    function replayStoredConsent() {
      if (!window.Cookiebot || window.Cookiebot.hasResponse) return;
      var stored = null;
      try { stored = localStorage.getItem(STORAGE_KEY); } catch (e) { return; }
      if (!stored) return;
      var s = readSettings();
      var hasDetail = s && (s.marketing || s.analytics || s.other);
      if (hasDetail) {
        notifyCookiebot(anyTrue(s.other), anyTrue(s.analytics), anyTrue(s.marketing));
      } else {
        var all = stored === 'accepted';
        notifyCookiebot(all, all, all);
      }
    }
    function anyTrue(group) {
      if (!group) return false;
      for (var k in group) { if (group[k]) return true; }
      return false;
    }
    // "Alles akzeptieren" / "Alles ablehnen" muessen auch die Detailauswahl
    // ueberschreiben (02.10.2026). Vorher blieb eine alte Einzelauswahl in
    // karinex_cookie_settings stehen und gewann beim naechsten Besuch gegen
    // den Klick auf "Alles ablehnen" (replayStoredConsent, kxConsent).
    // Einwilligung „Schutz vor Betrug“ umfasst seit 30.10.2026 auch die Gerätemerkmale am Computer
    // (Text T_fp_d). Wer sie mit dem neuen Text erteilt, bekommt zusätzlich other.fraud_fp; das
    // Sperr-Skript der App (karinex-guard.js) berechnet die Merkmale nur damit. Früher erteilte
    // Einwilligungen gelten weiter nur für die Kennung kx_dev. Kein eigener Schalter.
    function stampFraudFp(settings) {
      if (!settings || !settings.other) return settings;
      if (settings.other.fraud_protection === true) settings.other.fraud_fp = true;
      else delete settings.other.fraud_fp;
      return settings;
    }
    // Einwilligung „Persönliche Gutscheine“ (marketing.exit_voucher) umfasst seit dem neuen Text T_ei_d (03.11.2026) auch
    // den Gutschein, den die Inhaberin während des Besuchs schickt (Fenster auf der aktuellen Seite, Abfrage alle 20 s,
    // snippets/kx-live-angebot.liquid). Wer sie mit dem neuen Text erteilt, bekommt zusätzlich marketing.voucher_live; nur
    // damit fragt assets/kx-live-angebot.js die App. Früher erteilte Einwilligungen gelten weiter nur für den Gutschein beim
    // Verlassen. Kein eigener Schalter (Muster stampFraudFp); wer T_ei_d erneut inhaltlich ändert, braucht wieder so ein
    // Zusatz-Kennzeichen. Ohne exit_voucher wird es gelöscht.
    // Gesetzt wird es NUR bei einer aktiven Zustimmung zum neuen Wortlaut (EuGH Planet49, § 25 TDDDG): „Alles akzeptieren“
    // (neu = true) oder der Schalter wurde im offenen Einstellungsfenster selbst von aus auf an gestellt (voucherAktiv).
    // Sonst bleibt der alte Wert: ein Schalter, der beim Öffnen aus einer älteren Einwilligung vorbelegt an stand, erweitert
    // sie beim Speichern nicht still auf den Live-Gutschein.
    function stampVoucherLive(settings, neu) {
      if (!settings || !settings.marketing) return settings;
      var vorher = readSettings();
      var hatte = !!(vorher && vorher.marketing && vorher.marketing.voucher_live === true);
      if (settings.marketing.exit_voucher === true && (neu === true || hatte)) settings.marketing.voucher_live = true;
      else delete settings.marketing.voucher_live;
      return settings;
    }
    function setAllSettings(on) {
      var settings = {};
      var modal = document.getElementById('kxCookieSettingsModal');
      var toggles = modal ? modal.querySelectorAll('[data-cset-toggle]') : [];
      for (var i = 0; i < toggles.length; i++) {
        setValue(settings, toggles[i].getAttribute('data-cset-toggle'), !!on);
      }
      if (!toggles.length) settings = { other: { all: !!on }, analytics: { all: !!on }, marketing: { all: !!on } };
      writeSettings(stampVoucherLive(stampFraudFp(settings), !!on));
    }
    // Signal an window.kxConsent (snippets/kx-cookiebot.liquid): wartende
    // Funktionen pruefen ihre Kategorie neu, auch wenn Cookiebot blockiert ist.
    function announceConsent() {
      try { window.dispatchEvent(new Event('kx:consent')); } catch (e) {}
    }
    // Absorb the iOS "ghost click": the banner dismisses on `click` but stays in
    // the DOM for a 400ms close animation. As it slides away, Safari can dispatch
    // a delayed synthesized click at the same point that lands on whatever is now
    // underneath (e.g. the buy-together #kxBtMore button → opens its product
    // picker). A transparent, top-most shield installed synchronously in the tap
    // catches that stray click, then removes itself just after the animation.
    function swallowGhostClick() {
      var s = document.createElement('div');
      s.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483647;background:transparent;';
      (document.body || document.documentElement).appendChild(s);
      var kill = function (e) { e.stopPropagation(); e.preventDefault(); };
      s.addEventListener('click', kill, true);
      s.addEventListener('touchend', kill, true);
      setTimeout(function () { if (s.parentNode) s.parentNode.removeChild(s); }, 500);
    }
    function hide() {
      swallowGhostClick();
      banner.setAttribute('data-open', 'false');
      banner.dataset.open = 'false';
      if (backdrop) backdrop.setAttribute('data-open', 'false');
      setTimeout(function () {
        banner.style.display = 'none';
        if (backdrop) backdrop.style.display = 'none';
      }, 400);
    }
    function show() {
      banner.style.display = '';
      if (backdrop) backdrop.style.display = '';
      requestAnimationFrame(function () {
        banner.setAttribute('data-open', 'true');
        if (backdrop) backdrop.setAttribute('data-open', 'true');
      });
    }

    if (!alreadyAnswered()) {
      setTimeout(show, 600);
    }
    if (hadAnswered()) {
      // Frueher beantwortet (auch vor der aktuellen Version): Cookiebot muss die
      // damalige Auswahl kennen, bis neu entschieden ist (siehe replayStoredConsent).
      onCookiebotReady(replayStoredConsent);
    }

    banner.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-kx-cookie-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-kx-cookie-action');
      if (action === 'accept') {
        save('accepted');
        setAllSettings(true);
        notifyShopify('accepted');
        notifyCookiebot(true, true, true);
        announceConsent();
        hide();
      } else if (action === 'reject') {
        save('rejected');
        setAllSettings(false);
        notifyShopify('rejected');
        notifyCookiebot(false, false, false);
        announceConsent();
        hide();
      } else if (action === 'reject-open') {
        // "Nur technisch Erforderliches akzeptieren": record the essential-only
        // consent (keeps a truthful label + a one-click reject for GDPR/TTDSG
        // equal prominence) AND open the styled Erweiterte Einstellungen sheet so
        // the visitor can review/adjust. No hide() here — the sheet's own overlay
        // covers the banner; hiding would fire the ghost-click shield over the
        // just-opened modal (or a backdrop ghost-click would close it).
        save('rejected');
        setAllSettings(false);
        notifyShopify('rejected');
        notifyCookiebot(false, false, false);
        announceConsent();
        openSettings();
      } else if (action === 'settings') {
        openSettings();
      }
    });

    // === Erweiterte Einstellungen (Aufbau wie aboutyou.de, seit 30.10.2026) ===
    // Zwei Reiter: Kategorien mit ihren Diensten / Partnerliste mit einer Karte je Dienst.
    // Jeder Dienst-Schalter steht in beiden Reitern (gleiches data-cset-toggle); setToggle
    // haelt alle Kopien gleich. Gespeichert wird weiter in karinex_cookie_settings.
    var cset = document.getElementById('kxCookieSettingsModal');

    function readSettings() {
      try {
        var raw = localStorage.getItem(SETTINGS_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) { return {}; }
    }
    // Jede Antwort traegt die aktuelle Version (_v); die Gruppen other/analytics/marketing bleiben, wie sie sind.
    // Seit 02.11.2026 auch eine zufaellige Nummer des Browsers (_id) fuer den Nachweis, siehe protokollieren().
    function writeSettings(obj) {
      try {
        var o = obj && typeof obj === 'object' ? obj : {};
        o._v = CONSENT_VERSION;
        o._id = nummerVon(readSettings());
        localStorage.setItem(SETTINGS_KEY, JSON.stringify(o));
        protokollieren(o);
      } catch (e) {}
    }

    // === Nachweis der Einwilligung (Wunsch der Inhaberin vom 02.11.2026) ==========
    // Jede Antwort (auch Aenderung und Ruecknahme) geht einmal an das Protokoll der KARINEX-App (Ansicht
    // „Einwilligungen“, /api/public/einwilligung): zufaellige Nummer _id (bleibt in karinex_cookie_settings, kein
    // neuer Speicher-Schluessel), Version, die Schalter je Gruppe, Consent-ID von Cookiebot (falls schon da) und die
    // Sprache der Seite. Kein Name, keine E-Mail, kein Seitenpfad. Per sendBeacon als Text (kein Preflight, kommt auch
    // beim sofortigen Seitenwechsel an); die App speichert nur mit ihrem Schalter. Faellt das aus, aendert sich fuer
    // den Besucher nichts: die Auswahl wirkt wie bisher.
    var PROTOKOLL_URL = 'https://www.softwarefach.de/api/public/einwilligung';
    var nachCookiebot = false;
    function neueNummer() {
      try {
        var a = new Uint8Array(16);
        window.crypto.getRandomValues(a);
        var s = '';
        for (var i = 0; i < a.length; i++) s += ('0' + a[i].toString(16)).slice(-2);
        return s;
      } catch (e) { return ''; }
    }
    function nummerVon(alt) {
      return alt && typeof alt._id === 'string' && /^[a-f0-9]{32}$/.test(alt._id) ? alt._id : neueNummer();
    }
    function cookiebotId() {
      try { return (window.Cookiebot && window.Cookiebot.consentID) ? String(window.Cookiebot.consentID) : ''; } catch (e) { return ''; }
    }
    function protokollieren(o) {
      try {
        if (!o || !o._id) return;
        var cb = cookiebotId();
        var body = JSON.stringify({
          id: o._id, v: o._v,
          s: { other: o.other || {}, analytics: o.analytics || {}, marketing: o.marketing || {} },
          cb: cb, l: String(document.documentElement.lang || '').slice(0, 5)
        });
        // Cookiebot vergibt seine Consent-ID erst nach submitCustomConsent: dann einmal nachreichen (die App fuegt sie nur an)
        nachCookiebot = !cb;
        if (navigator.sendBeacon && navigator.sendBeacon(PROTOKOLL_URL, body)) return;
        if (window.fetch) fetch(PROTOKOLL_URL, { method: 'POST', body: body, mode: 'no-cors', credentials: 'omit', keepalive: true }).catch(function () {});
      } catch (e) {}
    }
    function cookiebotNachreichen() {
      if (!nachCookiebot || !cookiebotId()) return;
      nachCookiebot = false;
      var s = readSettings();
      if (s && s._id && s._v === CONSENT_VERSION) protokollieren(s);
    }
    window.addEventListener('CookiebotOnAccept', cookiebotNachreichen);
    window.addEventListener('CookiebotOnDecline', cookiebotNachreichen);
    window.addEventListener('CookiebotOnConsentReady', cookiebotNachreichen);
    function each(list, fn) { for (var i = 0; i < list.length; i++) fn(list[i]); }
    function setToggle(key, on) {
      each(cset.querySelectorAll('[data-cset-toggle="' + key + '"]'), function (sw) {
        sw.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }
    function syncMasters() {
      each(cset.querySelectorAll('[data-cset-master]'), function (sw) {
        var group = sw.getAttribute('data-cset-master');
        var allOn = true;
        each(cset.querySelectorAll('[data-cset-toggle^="' + group + '."]'), function (child) {
          if (child.getAttribute('aria-checked') !== 'true') allOn = false;
        });
        sw.setAttribute('aria-checked', allOn ? 'true' : 'false');
      });
    }
    function applySettingsToUI() {
      if (!cset) return;
      var settings = readSettings();
      each(cset.querySelectorAll('[data-cset-toggle]'), function (sw) {
        sw.setAttribute('aria-checked', getValue(settings, sw.getAttribute('data-cset-toggle')) ? 'true' : 'false');
      });
      syncMasters();
    }
    function getValue(obj, dotted) {
      var parts = dotted.split('.');
      var cur = obj;
      for (var i = 0; i < parts.length; i++) { cur = cur ? cur[parts[i]] : undefined; }
      return cur;
    }
    function setValue(obj, dotted, val) {
      var parts = dotted.split('.');
      var cur = obj;
      for (var i = 0; i < parts.length - 1; i++) {
        cur[parts[i]] = cur[parts[i]] || {};
        cur = cur[parts[i]];
      }
      cur[parts[parts.length - 1]] = val;
    }
    function setExpanded(btn, open) {
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (box) box.hidden = !open;
    }
    function showView(name) {
      each(cset.querySelectorAll('[data-cset-view-tab]'), function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-cset-view-tab') === name ? 'true' : 'false');
      });
      each(cset.querySelectorAll('[data-cset-view]'), function (v) {
        v.hidden = v.getAttribute('data-cset-view') !== name;
      });
    }
    // Partnerliste alphabetisch wie bei aboutyou.de (Namen in der Sprache der Seite).
    var sorted = false;
    function sortPartners() {
      var list = document.getElementById('kxCsetPartnerList');
      if (!list || sorted) return;
      sorted = true;
      var cards = [];
      each(list.querySelectorAll('[data-cset-pcard]'), function (c) { cards.push(c); });
      var lang = document.documentElement.lang || undefined;
      cards.sort(function (x, y) {
        var a = (x.querySelector('.kx-cset__card-title') || x).textContent.trim();
        var b = (y.querySelector('.kx-cset__card-title') || y).textContent.trim();
        try { return a.localeCompare(b, lang, { sensitivity: 'base' }); } catch (e) { return a < b ? -1 : a > b ? 1 : 0; }
      });
      each(cards, function (c) { list.appendChild(c); });
    }
    // ID der Einwilligung von Cookiebot (Datenschutzerklaerung Ziffer 21: Consent-ID); nur wenn vorhanden.
    function showConsentId() {
      var card = document.getElementById('kxCsetConsentId');
      var val = document.getElementById('kxCsetConsentIdValue');
      if (!card || !val) return;
      var id = '';
      try { id = (window.Cookiebot && window.Cookiebot.consentID) ? String(window.Cookiebot.consentID) : ''; } catch (e) {}
      if (id.length >= 8 && /^[A-Za-z0-9+\/=_-]+$/.test(id)) {
        val.textContent = id;
        card.hidden = false;
      } else {
        card.hidden = true;
      }
    }

    // true, sobald der Besucher „Persönliche Gutscheine“ in diesem offenen Fenster selbst von aus auf an stellt
    // (Schalter oder Kategorie-Hauptschalter), false beim Ausschalten (siehe stampVoucherLive).
    var voucherAktiv = false;
    var VOUCHER_KEY = 'marketing.exit_voucher';
    function voucherAn() {
      var sw = cset ? cset.querySelector('[data-cset-toggle="' + VOUCHER_KEY + '"]') : null;
      return !!(sw && sw.getAttribute('aria-checked') === 'true');
    }
    function openSettings() {
      if (!cset) return;
      voucherAktiv = false;
      sortPartners();
      applySettingsToUI();
      showConsentId();
      cset.setAttribute('data-open', 'true');
      document.documentElement.classList.add('kx-cset-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSettings() {
      if (!cset) return;
      cset.setAttribute('data-open', 'false');
      document.documentElement.classList.remove('kx-cset-open');
      document.body.style.overflow = '';
    }

    if (cset) {
      var scrollBox = document.getElementById('kxCsetScroll');
      cset.addEventListener('click', function (e) {
        if (e.target === cset) { closeSettings(); return; }
        if (e.target.closest('[data-cset-close]')) { closeSettings(); return; }

        var tab = e.target.closest('[data-cset-view-tab]');
        if (tab) { showView(tab.getAttribute('data-cset-view-tab')); return; }

        // "Alles ablehnen" / "Alles akzeptieren": gleiche Wirkung wie die Knoepfe des Hinweises.
        var allBtn = e.target.closest('[data-cset-all]');
        if (allBtn) {
          var yes = allBtn.getAttribute('data-cset-all') === 'accept';
          save(yes ? 'accepted' : 'rejected');
          setAllSettings(yes);
          notifyShopify(yes ? 'accepted' : 'rejected');
          notifyCookiebot(yes, yes, yes);
          announceConsent();
          closeSettings();
          hide();
          return;
        }

        // ⓘ in einer Kategorie: zur Karte des Dienstes in der Partnerliste springen und sie oeffnen.
        var go = e.target.closest('[data-cset-goto]');
        if (go) {
          var svc = go.getAttribute('data-cset-goto');
          var more = document.getElementById('kxCsetMore-' + svc);
          showView('partners');
          if (more) {
            setExpanded(more, true);
            var card = more.closest('[data-cset-pcard]');
            if (card && card.scrollIntoView) card.scrollIntoView({ block: 'start' });
            try { more.focus({ preventScroll: true }); } catch (err) { more.focus(); }
          }
          return;
        }

        var copy = e.target.closest('#kxCsetConsentIdCopy');
        if (copy) {
          var txt = (document.getElementById('kxCsetConsentIdValue') || {}).textContent || '';
          try { if (navigator.clipboard) navigator.clipboard.writeText(txt); } catch (err) {}
          copy.setAttribute('data-done', 'true');
          setTimeout(function () { copy.removeAttribute('data-done'); }, 1500);
          return;
        }

        var toggle = e.target.closest('[data-cset-toggle]');
        if (toggle) {
          if (!toggle.hasAttribute('disabled')) {
            var tKey = toggle.getAttribute('data-cset-toggle');
            var tVorher = voucherAn();
            setToggle(tKey, toggle.getAttribute('aria-checked') !== 'true');
            if (tKey === VOUCHER_KEY) {
              if (!voucherAn()) voucherAktiv = false;
              else if (!tVorher) voucherAktiv = true;
            }
            syncMasters();
          }
          return;
        }

        var masterBtn = e.target.closest('[data-cset-master]');
        if (masterBtn) {
          if (!masterBtn.hasAttribute('disabled')) {
            var grp = masterBtn.getAttribute('data-cset-master');
            var newState = masterBtn.getAttribute('aria-checked') !== 'true';
            var mVorher = voucherAn();
            masterBtn.setAttribute('aria-checked', newState ? 'true' : 'false');
            each(cset.querySelectorAll('[data-cset-toggle^="' + grp + '."]'), function (child) {
              child.setAttribute('aria-checked', newState ? 'true' : 'false');
            });
            if (VOUCHER_KEY.indexOf(grp + '.') === 0) {
              if (!voucherAn()) voucherAktiv = false;
              else if (!mVorher) voucherAktiv = true;
            }
          }
          return;
        }

        // Pfeil oder Kopfzeile einer Karte: auf- bzw. zuklappen (Schalter ausgenommen, siehe oben).
        var chev = e.target.closest('[data-cset-more]');
        if (!chev) {
          var head = e.target.closest('[data-cset-head]');
          if (head && !e.target.closest('a, .kx-cset__switch, .kx-cset__ibtn')) chev = head.querySelector('[data-cset-more]');
        }
        if (chev) setExpanded(chev, chev.getAttribute('aria-expanded') !== 'true');
      });

      cset.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') closeSettings();
      });

      var saveBtn = document.getElementById('kxCsetSave');
      if (saveBtn) {
        saveBtn.addEventListener('click', function () {
          var settings = {};
          each(cset.querySelectorAll('[data-cset-toggle]'), function (sw) {
            setValue(settings, sw.getAttribute('data-cset-toggle'), sw.getAttribute('aria-checked') === 'true');
          });
          writeSettings(stampVoucherLive(stampFraudFp(settings), voucherAktiv));

          var anyMarketing = anyTrue(settings.marketing);
          var anyAnalytics = anyTrue(settings.analytics);
          var anyOther = anyTrue(settings.other);

          save(anyMarketing || anyAnalytics || anyOther ? 'accepted' : 'rejected');
          // Kategorien 1:1 an Cookiebot: other→preferences, analytics→statistics,
          // marketing→marketing. Erst damit werden die passenden Skripte entsperrt.
          notifyCookiebot(anyOther, anyAnalytics, anyMarketing);
          announceConsent();
          withCustomerPrivacy(function (cp) {
            try {
              cp.setTrackingConsent({
                analytics: anyAnalytics,
                marketing: anyMarketing,
                preferences: anyOther,
                sale_of_data: anyMarketing
              }, function () {});
            } catch (e) {}
          });

          closeSettings();
          hide();
        });
      }
    }

    var moreBtn = document.getElementById('kxCookieMore');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var expanded = banner.getAttribute('data-expanded') === 'true';
        banner.setAttribute('data-expanded', expanded ? 'false' : 'true');
        moreBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        // Labels come translated from Liquid via data attributes (§9.7)
        moreBtn.textContent = expanded
          ? (moreBtn.getAttribute('data-label-more') || 'Mehr lesen…')
          : (moreBtn.getAttribute('data-label-less') || 'Weniger anzeigen');
      });
    }

    // Public hook: window.kxCookieBanner.show() to re-open later (e.g. from footer link)
    window.kxCookieBanner = {
      show: function () { try { localStorage.removeItem(STORAGE_KEY); } catch(e) {} show(); },
      hide: hide,
      openSettings: openSettings,
      closeSettings: closeSettings
    };
  })();
